import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { getToken } from '../login/login.saga';
import meloAttributeActions, { types } from './meloAttribute.actions';
import { MeloAttributeEntry } from '../jobs/jobs.types';

interface CreateAction { type: string; accountId: string; meLoId: string; entry: MeloAttributeEntry; }
interface UpdateAction { type: string; accountId: string; meLoId: string; attributeId: string; entry: MeloAttributeEntry; version: number; }
interface DeleteAction { type: string; accountId: string; meLoId: string; attributeId: string; }

function* createMeloAttribute({ accountId, meLoId, entry }: CreateAction) {
    try {
        const token: string = yield call(getToken, accountId);
        const { data } = yield axios.post(
            `/api/pro/melo-attribute/${encodeURIComponent(meLoId)}`,
            { entry },
            { headers: { Authorization: `Bearer ${token}` } },
        );
        yield put(meloAttributeActions.meloAttributeUpserted(meLoId, data));
        yield put(meloAttributeActions.saveDone());
    } catch (e: any) {
        yield put(meloAttributeActions.saveError(e?.response?.status === 409));
    }
}

function* updateMeloAttribute({ accountId, meLoId, attributeId, entry, version }: UpdateAction) {
    try {
        const token: string = yield call(getToken, accountId);
        const { data } = yield axios.put(
            `/api/pro/melo-attribute/${encodeURIComponent(meLoId)}/${encodeURIComponent(attributeId)}`,
            { entry, version },
            { headers: { Authorization: `Bearer ${token}` } },
        );
        yield put(meloAttributeActions.meloAttributeUpserted(meLoId, data));
        yield put(meloAttributeActions.saveDone());
    } catch (e: any) {
        // 409 aus dem PUT = Optimistic-Lock-Konflikt (Limit wird nur beim POST geprueft) -> stale, nicht conflict.
        yield put(meloAttributeActions.saveError(false, e?.response?.status === 409));
    }
}

function* deleteMeloAttribute({ accountId, meLoId, attributeId }: DeleteAction) {
    try {
        const token: string = yield call(getToken, accountId);
        yield axios.delete(
            `/api/pro/melo-attribute/${encodeURIComponent(meLoId)}/${encodeURIComponent(attributeId)}`,
            { headers: { Authorization: `Bearer ${token}` } },
        );
        yield put(meloAttributeActions.meloAttributeRemoved(meLoId, attributeId));
        yield put(meloAttributeActions.saveDone());
    } catch (e: any) {
        yield put(meloAttributeActions.saveError(e?.response?.status === 409));
    }
}

export function* meloAttributeSaga() {
    yield takeEvery(types.CREATE_MELO_ATTRIBUTE, createMeloAttribute);
    yield takeEvery(types.UPDATE_MELO_ATTRIBUTE, updateMeloAttribute);
    yield takeEvery(types.DELETE_MELO_ATTRIBUTE, deleteMeloAttribute);
}
